import React from 'react';
//import fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

function SideBar() {
    return (
        <>
            <aside id='sidebar' className='sidebar'>
                <ul className='sidebar-nav' id='sidebar-nav'>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/'>
                            <i className='bi bi-grid'></i>
                            <span>Dashboard</span>
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/batch/list'>
                            <i className='bi bi-people'></i>
                            <span>Mapped Batches</span>
                        </Link>
                    </li>
                    <li className='nav-item d-none'>
                        <Link className='nav-link collapsed' data-bs-target="#batch-nav" data-bs-toggle="collapse" to='#'>
                            <i className="bi bi-people me-2"></i>
                            <span>Batches</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='batch-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">

                            <li>
                                <Link to='/batch/list'>
                                    <i className='bi bi-arrow-right'></i>
                                    <span>Search Batch</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#paymentreports-nav" data-bs-toggle="collapse" to='#'>
                            <i className="bi bi-cash-coin me-2"></i>
                            <span> Payment Reports</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='paymentreports-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/report/student/collection/payment/'>
                                    <i className='bi bi-arrow-right'></i>
                                    <span>Collection Reports</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/report/student/pending/payment/'>
                                    <i className='bi bi-arrow-right'></i>
                                    <span>Pending Reports</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/report/monthly/payment/'>
                                    <i className='bi bi-arrow-right'></i>
                                    <span>Monthly Reports</span>
                                </Link>
                            </li>
                        </ul>

                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#attendancereports-nav" data-bs-toggle="collapse" to='#'>
                            <i className="bi bi-person-check me-2"></i>
                            <span> Attendance Reports</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='attendancereports-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/report/monthly/attendance/'>
                                    <i className='bi bi-arrow-right'></i>
                                    <span>Monthly Reports</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#lessonreports-nav" data-bs-toggle="collapse" to='#'>
                            <i className="bi bi-person-check me-2"></i>
                            <span> Lesson Reports</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='lessonreports-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/report/monthly/lessonplanner/'>
                                    <i className='bi bi-arrow-right'></i>
                                    <span>Monthly Reports</span>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <hr></hr>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/page/list'>
                            <i className="bi bi-info-circle"></i>
                            <span>Information</span>
                        </Link>
                    </li>
                </ul>
            </aside>
        </>
    )
}

export default SideBar